import { render, staticRenderFns } from "./ResearchTeam.vue?vue&type=template&id=001c8197&scoped=true"
import script from "./ResearchTeam.vue?vue&type=script&lang=js"
export * from "./ResearchTeam.vue?vue&type=script&lang=js"
import style0 from "./ResearchTeam.vue?vue&type=style&index=0&id=001c8197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001c8197",
  null
  
)

export default component.exports